$(document).on('click', '.vip_button_dat_custom ', function(e) {
e.preventDefault();

var data = 'VIP Price';
var new_var = [];
$(".grid.grid-small .grid__item").each(function(index) {
var var_nam = $(this).find('.single-option-list-type').val();
if (var_nam) {
new_var.push(var_nam);
}
});
    var new_datata = new_var.join(' / ');
new_var = new_var.join(' / ');

 console.log(new_var);   

if (new_var) {
var new_var_array = new_var.split(' / ');
new_var_array[new_var_array.length - 1] = data;
new_var = new_var_array.join(' / ');
}
console.log(new_var);
    var id = $('select[name="id"] option[variant_opt="'+new_var+'"]').val();
        $('select[name="id"]').val(id).trigger('change');

setTimeout(function(){
$('.vip_button_dat').click();
},500);

});



$(document).on('click', '.guest_button_dat', function(e) {
e.preventDefault();

var data = 'Guest Price';
var new_var = [];
$(".grid.grid-small .grid__item").each(function(index) {
var var_nam = $(this).find('.single-option-list-type').val();
if (var_nam) {
new_var.push(var_nam);
}
});
    var new_datata = new_var.join(' / ');
new_var = new_var.join(' / ');

 console.log(new_var);   

if (new_var) {
var new_var_array = new_var.split(' / ');
new_var_array[new_var_array.length - 1] = data;
new_var = new_var_array.join(' / ');
}
console.log(new_var);
    var id = $('select[name="id"] option[variant_opt="'+new_var+'"]').val();
        $('select[name="id"]').val(id).trigger('change');

setTimeout(function(){
$('.vip_button_dat').click();
},500);

});
